import React, { useState, useEffect } from "react";
import axios from "axios";
import { FileSignature, CheckCircle } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Onboarding() {
  const [step, setStep] = useState(1);
  const [packages, setPackages] = useState([]);
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", package: "" });

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/packages`);
      setPackages(res.data);
      if(res.data.length > 0) {
        setFormData(f => ({...f, package: res.data[0].name}));
      }
    } catch(e) { console.error(e); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${BACKEND_URL}/api/onboarding`, formData);
      setStep(2);
    } catch(e) {
      console.error(e);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-main_bg relative p-6">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1774864040225-867c8806d78e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBkYXJrJTIwZ3ltJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc1MjgyMDI5fDA&ixlib=rb-4.1.0&q=85')] bg-cover bg-center opacity-10"></div>
      
      <div className="relative z-10 glass-panel p-10 rounded-2xl max-w-lg w-full border border-gray-200 shadow-2xl">
        <h1 className="text-3xl font-serif text-primary text-center mb-2">SVT Golden</h1>
        <p className="text-gray-500 text-center mb-8 text-sm uppercase tracking-widest">Self Onboarding</p>

        {step === 1 ? (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs text-gray-500 block mb-1">Full Name</label>
              <input required type="text" value={formData.name} onChange={e=>setFormData({...formData, name: e.target.value})} className="w-full bg-main_bg border border-gray-200 rounded-md p-3 text-text_primary focus:outline-none focus:border-primary" />
            </div>
            <div>
              <label className="text-xs text-gray-500 block mb-1">Email</label>
              <input required type="email" value={formData.email} onChange={e=>setFormData({...formData, email: e.target.value})} className="w-full bg-main_bg border border-gray-200 rounded-md p-3 text-text_primary focus:outline-none focus:border-primary" />
            </div>
            <div>
              <label className="text-xs text-gray-500 block mb-1">Phone</label>
              <input required type="tel" value={formData.phone} onChange={e=>setFormData({...formData, phone: e.target.value})} className="w-full bg-main_bg border border-gray-200 rounded-md p-3 text-text_primary focus:outline-none focus:border-primary" />
            </div>
            <div>
              <label className="text-xs text-gray-500 block mb-1">Select Package</label>
              <select required value={formData.package} onChange={e=>setFormData({...formData, package: e.target.value})} className="w-full bg-main_bg border border-gray-200 rounded-md p-3 text-text_primary focus:outline-none focus:border-primary appearance-none">
                {packages.length === 0 && <option value="">Loading packages...</option>}
                {packages.map(pkg => (
                  <option key={pkg.id} value={pkg.name}>{pkg.name} (₹{pkg.price.toLocaleString()})</option>
                ))}
              </select>
            </div>
            <button type="submit" disabled={packages.length===0} className="w-full mt-6 py-4 bg-primary text-white font-bold rounded-full hover:bg-primary_hover transition-transform hover:scale-105 duration-200 flex items-center justify-center gap-2 disabled:opacity-50">
              <FileSignature size={20} /> Register & Join
            </button>
          </form>
        ) : (
          <div className="text-center space-y-4 py-8">
            <CheckCircle size={60} className="text-accent_success mx-auto" />
            <h2 className="text-2xl font-serif text-text_primary">Registration Successful</h2>
            <p className="text-gray-500 text-sm">Our reception team will contact you shortly with app login details and your invoice.</p>
          </div>
        )}
      </div>
    </div>
  );
}
